export default __webpack_public_path__ + "static/media/11_rusalka.c7641e60.png";